import { BarcodeOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { gray } from 'sutra/tokens/colors'

export const NameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const NameText = styled.span`
  overflow-wrap: anywhere;
`

/** A grouped theme's subtheme (child) row branches off its parent — this is
 * the "└" glyph in front of its name. */
export const TreeConnector = styled.span`
  color: ${gray[400]};
`

export const Thumbnail = styled.img`
  height: 32px;
  width: 32px;
  object-fit: contain;
  border-radius: 4px;
`

export const SourceIconWrapper = styled.div`
  width: 24px;
  height: 24px;

  svg,
  img {
    width: 100%;
    height: 100%;
  }
`

export const BarcodeIcon = styled(BarcodeOutlined)`
  font-size: 20px;
`
